"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseFloatPrecision = void 0;
require("core-js/modules/es.parse-float.js");
var parseFloatPrecision = exports.parseFloatPrecision = function parseFloatPrecision(num) {
  var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 12;
  return +parseFloat(num.toPrecision(precision));
};